import { SubscriptionSeatTypes } from "@safetyculture/s12-apis-connect-web/s12/common/seat_types_pb";

interface componentsMap {
  [component: string]: string;
}

export const userSeatsToString: componentsMap = {
  userSeatsFreeTeam: "Free",
  userSeatsPremium: "Full",
  userSeatsPremiumQuarterly: "Full",
  userSeatsPremiumBiannual: "Full",
  userSeatsPremiumAnnual: "Full",
  userSeatsActionsOnly: "Actions Only",
  userSeatsIncidentsOnly: "Incidents Only",
  userSeatsActionsIncidentsOnly: "Actions & Incidents Only",
  userSeatsCollaborator: "Free",
  userSeatsPremiumTwoYear: "Full",
  userSeatsPremiumThreeYear: "Full",
  userSeatsLite: "Lite",
  "user-seats-premium": "Full",
  "user-seats-premium-annual": "Full",
  "user-seats-premium-quarterly": "Full",
  "user-seats-premium-biannual": "Full",
  "user-seats-premium-2year": "Full",
  "user-seats-premium-3year": "Full",
  "user-seats-lite": "Lite",
  "user-seats-free-team": "Free",
  "user-seats": "Full",
  "user-seats-collaborator": "Free",
  "ai-credit-bundle": "AI Credit Bundle",
  "ai-credit-overage": "AI Credit Overage",
  "Full Seat | Monthly": "Full",
  "Full Seat | Quarterly": "Full",
  "Full Seat | Half-Yearly": "Full",
  "Full Seat | Annual": "Full",
  "Full Seat | 2-year": "Full",
  "Full Seat | 3-year": "Full",
  "Free Seat": "Free",
  "Lite seat": "Lite",
  "Extra Devices | Monthly": "Extra Devices",
  "Extra Devices | Quarterly": "Extra Devices",
  "Extra Devices | Half-Yearly": "Extra Devices",
  "Extra Devices | Annual": "Extra Devices",
  "Extra Devices | 2-year": "Extra Devices",
  "Extra Devices | 3-year": "Extra Devices",
  discount: "Discount",
  "sensor-plan-unit": "Sensor",
  "enterprise-package": "Enterprise Package",
};

export const AIOU_USER_SEATS = [
  "userSeatsActionsOnly",
  "userSeatsIncidentsOnly",
  "userSeatsActionsIncidentsOnly",
];

export enum ChargifyKeySeatType {
  USER_SEATS = "user-seats",
  USER_SEATS_PREMIUM_MONTHLY = "user-seats-premium",
  USER_SEATS_PREMIUM_ANNUAL = "user-seats-premium-annual",
  USER_SEATS_PREMIUM_QUARTERLY = "user-seats-premium-quarterly",
  USER_SEATS_PREMIUM_BIANNUAL = "user-seats-premium-biannual",
  USER_SEATS_PREMIUM_TWO_YEAR = "user-seats-premium-2year",
  USER_SEATS_PREMIUM_THREE_YEAR = "user-seats-premium-3year",
  USER_SEATS_ACTIONS_ONLY = "user-seats-actions-only",
  USER_SEATS_INCIDENTS_ONLY = "user-seats-incidents-only",
  USER_SEATS_ACTIONS_INCIDENTS_ONLY = "user-seats-actions-incidents-only",
  USER_SEATS_COLLABORATOR = "user-seats-collaborator",
  USER_SEATS_LITE = "user-seats-lite",
}

export enum SoterSeatType {
  Collaborator = "collaborator",
  Premium = "premium",
  Lite = "lite",
}

export const PREMIUM_CHARGIFY_KEY_SEAT_TYPES = [
  ChargifyKeySeatType.USER_SEATS_PREMIUM_MONTHLY,
  ChargifyKeySeatType.USER_SEATS_PREMIUM_ANNUAL,
  ChargifyKeySeatType.USER_SEATS_PREMIUM_QUARTERLY,
  ChargifyKeySeatType.USER_SEATS_PREMIUM_BIANNUAL,
  ChargifyKeySeatType.USER_SEATS_PREMIUM_TWO_YEAR,
  ChargifyKeySeatType.USER_SEATS_PREMIUM_THREE_YEAR,
  ChargifyKeySeatType.USER_SEATS_LITE,
];

export const subscriptionSeatTypesMapping = {
  [SubscriptionSeatTypes.SUBSCRIPTION_SEAT_TYPE_UNSPECIFIED]: "N/A",
  [SubscriptionSeatTypes.SUBSCRIPTION_SEAT_TYPE_PREMIUM]: "Full",
  [SubscriptionSeatTypes.SUBSCRIPTION_SEAT_TYPE_COLLABORATOR]: "Free",
  [SubscriptionSeatTypes.SUBSCRIPTION_SEAT_TYPE_LITE]: "Lite",
  [SubscriptionSeatTypes.SUBSCRIPTION_SEAT_TYPE_SERVICE_USER]: "",
  [SubscriptionSeatTypes.SUBSCRIPTION_SEAT_TYPE_SUPPORT]: "Support",
};

export const stringToSubscriptionSeatTypesMapping: {
  [key: string]: SubscriptionSeatTypes;
} = {
  full: SubscriptionSeatTypes.SUBSCRIPTION_SEAT_TYPE_PREMIUM,
  premium: SubscriptionSeatTypes.SUBSCRIPTION_SEAT_TYPE_PREMIUM,
  free: SubscriptionSeatTypes.SUBSCRIPTION_SEAT_TYPE_COLLABORATOR,
  guest: SubscriptionSeatTypes.SUBSCRIPTION_SEAT_TYPE_COLLABORATOR,
  lite: SubscriptionSeatTypes.SUBSCRIPTION_SEAT_TYPE_LITE,
};

// Maps a raw seat type name (e.g. "PREMIUM", "COLLABORATOR") to the
// customer-facing label used across the app.
export const seatTypeNameToLabel: { [key: string]: string } = {
  PREMIUM: "Full",
  LITE: "Lite",
  COLLABORATOR: "Free",
};

// Resolves a raw seat type name to its customer-facing label. Falls back to
// title-casing the raw value (underscores become spaces) for unmapped names.
export const seatTypeLabel = (seatType: string): string => {
  if (!seatType) return "";
  const mapped = seatTypeNameToLabel[seatType.toUpperCase()];
  if (mapped) return mapped;
  const spaced = seatType.replace(/_/g, " ");
  return spaced.charAt(0).toUpperCase() + spaced.slice(1).toLowerCase();
};

export const PREMIUM_SEATS_MAX_SEATS_UPPER_DEFAULT = 200000;
export const PREMIUM_SEATS_MAX_SEATS_DEFAULT = 25000;
export const MIN_FULL_SEATS = 1;
export const MIN_LITE_SEATS = 0;
